import { render, staticRenderFns } from "./PhotoProfileGroupChat.vue?vue&type=template&id=2ef89ac7"
import script from "./PhotoProfileGroupChat.vue?vue&type=script&lang=js"
export * from "./PhotoProfileGroupChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports